import { jsx as _jsx } from "react/jsx-runtime";
import { getOrderRelatedItemById, isNonEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { ItemImage } from '../../../subcomponents/item-image/item-image';
import { FilmThumbnailUI } from '../../film/thumbnail/subcomponents/ui';
import { MemberJourneyListContextInstance } from '../types/context';
import { getClassModifiersForJourneyGroupType } from '../utils/get-class-modifiers-for-journey-group-type';
import { getFeaturedFilmForJourney } from '../utils/get-featured-film-for-journey';
const b = bemClassBuilder('v-member-journey-list-journey-thumbnail');
export const MemberJourneyListJourneyThumbnail = observer(props => {
    const { journey, journeyGroupType } = props;
    const { cdnOptions, config } = useContext(MemberJourneyListContextInstance);
    const { filmMediaType } = config;
    const film = getFeaturedFilmForJourney(journey);
    if (!!film) {
        return (_jsx("div", Object.assign({ className: b.block(getClassModifiersForJourneyGroupType(journeyGroupType, filmMediaType)) }, { children: _jsx(FilmThumbnailUI, { film: film, config: { mediaType: config.filmMediaType, showWatchlistButton: false }, events: {}, cdnOptions: cdnOptions.filmThumbnailImage }) })));
    }
    // No showtime in journey; find an item
    const orderWithItems = journey.orders.find(order => isNonEmptyArray(order.items));
    if (!orderWithItems) {
        throw new Error(`Could not find an order containing items in journey with id ${journey.id}`);
    }
    const item = getOrderRelatedItemById(orderWithItems.items[0].itemId);
    if (!item) {
        throw new Error(`Cannot find item with id: ${orderWithItems.items[0].itemId}`);
    }
    return (_jsx("div", Object.assign({ className: b.block(getClassModifiersForJourneyGroupType(journeyGroupType, filmMediaType)) }, { children: _jsx(ItemImage, { item: item, cdnOptions: cdnOptions.itemImage }) })));
});
MemberJourneyListJourneyThumbnail.displayName = 'MemberJourneyListJourneyThumbnail';
